import React, { Component } from "react"
import * as SelectionFactoryHelper from "../../../helpers/SelectionFactoryHelper"
import Svg from "../../../../shared/_svgs/svg"
import { Link } from "react-scroll"
import { isMobile } from "react-device-detect"
import Emitter from "../../../../helpers/emitter"
import * as emits from "../../../../constants/emits"

export default class MerchantPageContactUs extends Component {
  getCoordinateString(coordinate) {
    const coordinateString = coordinate?.toString()
    return coordinateString?.substring(0, 2) + "." + coordinateString?.substring(2, coordinateString?.length) || ""
  }

  openModal() {
    console.debug("clicked")
    Emitter.emit("*", {
      type: emits.REQUEST_MERCHANT_CONTACT_MODAL,
      modalJson: {
        shopName: this.props.pageTitle,
        ...this.props.contactUsSettings,
      },
    })
  }

  render() {
    const locationIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.locationIcon)
    const phoneIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.telephoneIcon)
    const mapIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.mapIcon)
    const shopLocation = SelectionFactoryHelper.getFromSelectionFactory(this.props.shopLocation)
    const scrollOffset = document.querySelector(".js--site-header").offsetHeight + 10

    const latitude = this.getCoordinateString(this.props.latitude)
    const longitude = this.getCoordinateString(this.props.longitude)

    const pointer = { cursor: "pointer" }

    var mapLink = (
      <Link style={pointer} to="mapSection" smooth={true} offset={-scrollOffset}>
        <li data-epi-edit="MapPlacementLabel">
          <Svg iconName={mapIcon || "arrowright"} />
          {this.props.mapPlacementLabel}
        </li>
      </Link>
    )

    if (latitude && longitude && isMobile) {
      mapLink = (
        <a style={pointer} href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}>
          <li data-epi-edit="MapPlacementLabel">
            <Svg iconName={mapIcon || "arrowright"} />
            {this.props.mapPlacementLabel}
          </li>
        </a>
      )
    }

    let grabIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.grabButtonIcon)

    return (
      <div className="shoppage__contactbox">
        <div className="shoppage__contactbox__content">
          <div className="left-side">
            <div className="store-image">
              <img src={this.props.image} data-epi-edit="Image" />
            </div>
          </div>
          <div className="right-side">
            <div className="description">
              <h2 data-epi-edit="Headline">{this.props.headline}</h2>
              <div className="maintext" data-epi-edit="Text">
                {this.props.text}
              </div>
            </div>
            {this.props.buttonLink ? (
              <a href={this.props.buttonLink}>
                <div className="button button--small button--general">
                  <span className="text" data-epi-edit="ButtonText">
                    {this.props.buttonText}
                  </span>
                </div>
              </a>
            ) : (
              <div className="button button--small button--general" onClick={() => this.openModal()}>
                <span className="text" data-epi-edit="ButtonText">
                  {this.props.buttonText}
                </span>
              </div>
            )}
            <ul>
              {this.props.location && (
                <li data-epi-edit="Location">
                  <Svg iconName={locationIcon || "pin"} />
                  {this.props.location} {shopLocation ? ` - ${shopLocation}` : ""}
                </li>
              )}
              {this.props.otherLocations && this.props.otherLocations.hasOtherLocations ? (
                <a href={this.props.otherLocations.otherLocationsLink}>
                  <li>
                    <Svg iconName={this.props.otherLocations.otherLocationsIcon || "pin"} />
                    {this.props.otherLocations.otherLocationsLabel}
                  </li>
                </a>
              ) : (
                ""
              )}
              {this.props.phone && (
                <li>
                  <Svg iconName={phoneIcon || "telephone"} />
                  {this.props.phone}
                </li>
              )}
              {this.props.mapPlacementLabel && mapLink}
            </ul>
          </div>
          <ul className="usp-buttons">
            {this.props.buttonContentArea &&
              this.props.buttonContentArea.map((button, index) => {
                const icon = SelectionFactoryHelper.getFromSelectionFactory(button.uspIcon)
                return (
                  <li key={index}>
                    <a href={button.uspLink || undefined}>
                      <div className="button button--small button--general no-shadow has-icon">
                        <Svg iconName={icon} />
                        <span className="text" data-epi-edit="UspText">
                          {button.uspText}
                        </span>
                      </div>
                    </a>
                  </li>
                )
              })}
            {this.props.grabLink && this.props.grabPreOrderText ? (
              <li>
                <a href={this.props.grabLink}>
                  <div className="button button--small button--general no-shadow has-icon">
                    <Svg iconName={grabIcon ?? "fooddrink"} />
                    <span className="text">{this.props.grabPreOrderText}</span>
                  </div>
                </a>
              </li>
            ) : (
              ""
            )}
          </ul>
        </div>
      </div>
    )
  }
}
